var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"Value") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":10},"end":{"line":10,"column":17}}})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"item\">\n              <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"Translate") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":7,"column":48},"end":{"line":7,"column":66}}}))
    + ":</span>\n              <span class=\"leaflet-popup-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"Value") : depth0), depth0))
    + "</span>\n            </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"item\">\n              <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.Brand",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":48},"end":{"line":14,"column":71}}}))
    + ":</span>\n              <span class=\"leaflet-popup-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"BrandName") : depth0), depth0))
    + "</span>\n          </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"Address") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":10},"end":{"line":24,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"Neighborhood") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":10},"end":{"line":30,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"City") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":10},"end":{"line":38,"column":17}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"item\">\n                <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.Address",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":21,"column":50},"end":{"line":21,"column":75}}}))
    + ":</span>\n                <span class=\"leaflet-popup-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"Address") : depth0), depth0))
    + "</span>\n            </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"item\">\n                <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.District",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":27,"column":50},"end":{"line":27,"column":76}}}))
    + ":</span>\n                <span class=\"leaflet-popup-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"Neighborhood") : depth0), depth0))
    + "</span>\n            </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"Uf") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":12},"end":{"line":37,"column":19}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "               <div class=\"item\">\n                  <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.City",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":34,"column":52},"end":{"line":34,"column":74}}}))
    + ":</span>\n                  <span class=\"leaflet-popup-text\">"
    + alias1(alias2((depth0 != null ? lookupProperty(depth0,"City") : depth0), depth0))
    + ", "
    + alias1(alias2((depth0 != null ? lookupProperty(depth0,"Uf") : depth0), depth0))
    + "</span>\n               </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n    <div class=\"leaflet-popup-header\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "</div>\n    <div class=\"leaflet-popup-fuel-station\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"ParameterTemplates") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":11,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"BrandName") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":17,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"IsEletricStation") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":39,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-fuel-station-popup.hbs
// module id = sZNp
// module chunks = 1